import React, { useEffect, useRef, useState } from 'react';
import { EpisodeValidationResponse } from '../types/ContestTypes';
import { api } from '../../../../../api';

const episodeBookError = 'This episode does not belong to the promotion story';

export function EpisodeBookValidationMessage(props: {
  storyUuid: string | null;
  episodeUuid: string;
}) {
  const { storyUuid, episodeUuid } = props;
  const story = storyUuid?.trim() ?? '';
  const episode = episodeUuid?.trim() ?? '';
  const [error, setError] = useState('');
  const seqRef = useRef(0);

  useEffect(() => {
    if (story.length !== 36 || episode.length !== 36) {
      setError('');
      return;
    }
    const seq = ++seqRef.current;
    const handle = window.setTimeout(() => {
      api
        .get<EpisodeValidationResponse>('/v1/tools/promotions/validate-episode', {
          params: { storyUuid: story, episodeUuid: episode },
        })
        .then((res) => {
          if (seqRef.current !== seq) return;
          setError(res.data?.valid ? '' : episodeBookError);
        })
        .catch(() => {
          if (seqRef.current !== seq) return;
          setError('');
        });
    }, 300);
    return () => window.clearTimeout(handle);
  }, [story, episode]);

  if (!error) return null;
  return <div className="text-danger small mt-1">{error}</div>;
}

export { episodeBookError };
